<template>
  <div>


    <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#fff"
      text-color="#1b2b39"
      active-text-color="#337ab7" style="margin-bottom: 20px"
    >
      <audio ref="myAudio" id="myAudio" muted="" style="display: none">
        <source src="../common/music/warning.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
      <audio ref="allMusicPlay" id="allMusicPlay" loop="loop" muted="" style="display: none">
        <source src="../common/music/indexWarning.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>

      <el-menu-item index="2" style="float: right">
        <el-dropdown>
          <span class="el-dropdown-link">
            {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <router-link   :to="{name:'usefInfo'}">
              <el-dropdown-item>
                <i class="iconfont icon-icon">{{$t('Header.Personal')}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </i>
              </el-dropdown-item>
            </router-link>
<!--            <a href="http://cloudsms.hzjly.cn/charge/index.html">-->
<!--              <el-dropdown-item>-->
<!--                <i class="iconfont icon-renminbi"> {{balance}}</i>-->
<!--              </el-dropdown-item>-->
<!--            </a>-->
            <router-link   :to="{name:'login',query :{isAllpage:1}}">
              <el-dropdown-item>
                <i class="iconfont icon-tuichu3"> {{$t('Header.Drop')}}</i>
              </el-dropdown-item>
            </router-link>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu-item>
      <!--<el-menu-item index="1" style="float: right" class="hovercompany">-->
        <!--<a href="/#/companybundle/index">-->
          <!--<img width="24" style="position: relative;" :src="companyplaninfo[0].logo">-->
          <!--{{companyname}}-->
          <!--<div class="showcompany" @click.prevent='goto'>-->
            <!--<div>-->
              <!--<p style="color:#d78f52;font-size: 20px">{{companyplaninfo[0].planname}}</p>-->
              <!--<p style="font-size: 14px;color: #57585a" v-show="companyplaninfo[0].endtime!=''">{{$t('Header.Willbe')}}-->
                <!--{{companyplaninfo[0].endtime.substring(0,11)}} {{$t('Header.Expire')}}</p>-->
              <!--<p style="font-size: 14px;color: #57585a" v-show="companyplaninfo[0].endtime==''">-->
                <!--{{$t('Header.upgradeIcon')}}</p>-->
            <!--</div>-->
            <!--<div style="margin-left: auto;">-->
              <!--<el-button type="warning" v-show="companyplaninfo[0].endtime!=''">{{$t('Header.renewal')}}</el-button>-->
              <!--<el-button type="warning" v-show="companyplaninfo[0].endtime==''">{{$t('Header.upgradeNow')}}</el-button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</a>-->
      <!--</el-menu-item>-->

      <!--<el-menu-item index="3" style="float: right">-->
        <!--<el-select v-model="language" placeholder="" @change="languageChange" style="width: 100px;">-->
          <!--<el-option-->
            <!--label="中文"-->
            <!--value="zh_cn">-->
          <!--</el-option>-->
          <!--<el-option-->
            <!--label="English"-->
            <!--value="en_us">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</el-menu-item>-->


      <!--<el-menu-item index="5" style="float: right">-->
        <!--<a href="http://cloud.hzjly.cn/#/Index">{{$t('Header.GoBack')}}</a>-->
      <!--</el-menu-item>-->
      <el-menu-item index="4" style="float: right">
        <el-switch
          v-model="musicopen"
          :inactive-text="$t('Header.WebAlarm')" @change="changeMusic"

          v-if="SHUWMUSIC"
        >
        </el-switch>
      </el-menu-item>

      <a href="/#/Index">
        <img :src="ImgUrl"  style="margin: 15px 0 0 15px" />
      </a>

    </el-menu>

    <el-dialog
      :title="$t('Header.Noticereminder')"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div style="width: 100%; height: 500px; overflow-y: auto;">
        <p style="line-height: 26px;">{{$t('Header.line1')}}：</p>
        <p style="text-indent: 2em; line-height: 26px;">
          {{$t('Header.line2')}}。</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line3')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">
          {{$t('Header.line4')}}。</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line5')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line6')}}：</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line7')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line8')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line9')}}。</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line10')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">
          {{$t('Header.line11')}}。</p>
        <p style="text-indent: 2em; line-height: 26px;">{{$t('Header.line12')}}</p>
        <p style="text-indent: 2em; line-height: 26px;">
          {{$t('Header.line13')}}。</p>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">{{$t('Header.Read')}}</el-button>
  </span>
    </el-dialog>


    <el-dialog
      :title="$t('Header.Datatransfer')"
      :visible.sync="Transferdialog"
      width="50%"
    >
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="Transferdialog = false">{{$t('Header.Read')}}</el-button>
    </span>
    </el-dialog>


    <el-dialog
      :title="$t('Header.Remind')"
      :visible.sync="Companydialog"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="35vh"
    >
      <p class="remind">{{$t('Header.Msg')}}</p>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary"
                       @click="Companydialog = false;dialogFormVisible=true">{{$t('Header.Joincompany')}}</el-button>
             <router-link to="company/CreateCompany">
               <el-button type="primary" @click="Companydialog = false">{{$t('Header.Startcompany')}}</el-button>
            </router-link>
      </span>
    </el-dialog>


    <el-dialog :title="$t('Header.Joincompany')" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item :label="$t('Header.Invitationcode')">
          <el-input v-model="form.Code" autocomplete="off" class="input_two"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t('AllPage.Cancel')}}</el-button>
        <el-button type="primary" @click="JoinCompany">{{$t('AllPage.Sure')}}</el-button>
      </div>
    </el-dialog>

  </div>


</template>

<script>

  export default {
    name: "Header",
    created() {
      this.getUserInfo();


    },
    data() {
      return {
        SHUWMUSIC:false,
        language: 'zh_cn',
        userName: '',
        musicopen: true,
        activeIndex2: '0',
        companyplaninfo: [
          {
            logo: 'http://static.hzjly.cn/img/v1.png',
            planname: '标准会员',
            endtime: '',
          }
        ],
        devInfo: [],
        companyname: '',
        balance: '',
        dialogVisible: false,
        Transferdialog: false,
        Companydialog: false,
        dialogFormVisible: false,

        form: {
          Code: '',

        },
      }
    },
    mounted() {
      let _this = this;


      setTimeout(function () {
        _this.SHUWMUSIC = _this.$common.checkPower('8d1e6bfd-17a7-4a7e-9e9a-e4b92845dbd9')
      }, 2000)


      document.getElementById('myAudio').onclick = function (event) {
        document.getElementById('myAudio').play();
      }
      if(this.$cookies.get('language')==null){
        this.language = 'zh_cn';
        // set domain
        this.$cookies.set("language",this.language,"24d", '/',  window.config.domain);
      }else{
        this.language = this.$cookies.get('language');
      }
      //获取title
      this.$axios.get(this.configUrl+"/User/GetUserInfo?guid=", {
        params: {}
      })
        .then(res => {
          var data = res.data;
          data = JSON.parse(data);
          if (data.results.result.companyplaninfo.length == 0) {
            this.companyplaninfo = [{logo: "http://static.hzjly.cn/img/v1.png", planname: "标准会员", endtime: ''}]
          } else {
            this.companyplaninfo = data.results.result.companyplaninfo;
          }


        })
        .catch(err => {

        });

    },
    methods: {
      languageChange() {
        this.$i18n.locale = this.language;
        this.$cookies.set('language', this.language,"24d", '/',  window.config.domain);
        this.$router.go(0)
      },
      changeMusic(e) {
        if (e == false) {
          console.log('音乐关闭');
          document.getElementById('allMusicPlay').pause();
        } else {

        }


      },
      getDevNumber() {
        //获取设备数量
        this.$axios.get(this.configUrl+"/Dev/DevStatusCount", {
          params: {}
        })
          .then(res => {

            var data = res.data;
            data = JSON.parse(data);
            data = data.results.rows;
            this.devInfo = data[0];
            if (this.devInfo.overcount > 0) {
              if (this.musicopen == true) {
                //允许播放
                document.getElementById('allMusicPlay').pause();//先暂停之前的
                document.getElementById('allMusicPlay').play();
              } else {

              }

            } else {//如果为正常 默认开启报警
              this.musicopen = true;
            }
          })
          .catch(err => {

          });
      },
      getWarning() {

        let _this = this;

        this.$axios.get(this.configUrl + "/AlarmRule/AlarmRuleWebWarnList", {
          params: {}
        })
          .then(res => {


            var data = res.data;
            data = JSON.parse(data);
            // data.results.rows=["[监测平台]尊敬的用户，您的设备190300498于2020/3/11 10:19:08：恢复正常,请及时处理", "[监测平台]尊敬的用户，您的设备190300498于2020/3/11 10:19:08：通道超标,请及时处理"]

            if (data.results.rows.length > 0) {
              data.results.rows.forEach(item => {
                setTimeout(function () {
                  _this.$notify({
                    title: '报警',
                    // type: 'warning',
                    duration: 0,
                    offset: 50,
                    message: item,
                    position: 'bottom-right'
                  });
                  _this.isSupportNotify(item)
                }, 500)
              })
              document.getElementById("myAudio").click();
            } else {


            }


          })
          .catch(err => {

          });
      },
      //浏览器是否支持显示通知   需要注意的是 只有 HTTPS 协议才能浏览器才能通过通知的功能，否则浏览器是强制关闭改功能的
      isSupportNotify: function (str) {
        if (window.Notification) {
          // 支持
          console.log("支持" + "Web Notifications API");
          this.isAllowNotify(str)
        } else {
          // 不支持
          console.log("不支持" + "Web Notifications API");
        }
      },
      //通知功能 有骚扰用户的嫌疑，让用户根据自己喜好选择是否开启通知权限
      isAllowNotify: function (str) {
        var _this = this;
        if (window.Notification && Notification.permission !== "denied") {
          Notification.requestPermission(function (status) {
            console.log(status);
            if (status === "granted") {
              _this.setNotification(str);
            } else {
              var n = new Notification("拒绝通知就看不到精彩资讯了哦！如要接受请在设置中选择允许接收通知。");
            }

          });
        }
      },
      //编辑通知内容并加上各个点击事件等  后期控制点击通知跳转到文章
      setNotification: function (str) {
        var notify = new Notification(this.$t('JS.devalarm'), {
          body: str,
          lang: "zh-CN",
          // icon:"http://backend.jin6.com/@webroot/uploads/image/20180423/1524455833949078.png"
        });
        notify.onshow = function () {
          console.log('Notification showning!');
        };
        notify.onclick = function () {
          console.log('Notification have be click!');
        };
        notify.onerror = function () {
          console.log('error!');
          // 手动关闭
          notify.close();
        };
        notify.onclose = function () {
          console.log("close");
        }
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          this.$axios.get(this.configUrl+"/Company/ListCompany", {
            params: {companyname: query}
          })
            .then(res => {
              var data = JSON.parse(res.data);
              this.loading = false;
              if (data.results.rows) {

                this.transferCompanyOptions = data.results.rows;
              } else {
                this.$message({
                  message: data.results.data,
                  type: 'warning'
                });
              }
            })
            .catch(err => {

            });


          // setTimeout(() => {
          //     this.loading = false;
          //     this.transferCompanyOptions = this.list.filter(item => {
          //         return item.label.toLowerCase()
          //             .indexOf(query.toLowerCase()) > -1;
          //     });
          // }, 200);
        } else {
          this.options = [];
        }
      },
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
        // this.$router.push({path: key});
      },
      getUserInfo() { //获取信息
        this.$axios.get(this.configUrl + "/user/GetUserInfo", {
          params: {}
        })
          .then(res => {
            let _this = this;
            var data = res.data;
            data = JSON.parse(data);
            data = data.results.result;
            localStorage.setItem('userInfo', JSON.stringify(data));
            this.userName = data.username;
            this.companyname = data.companyname;

            if (this.$common.checkPower('8d1e6bfd-17a7-4a7e-9e9a-e4b92845dbd9')) {
              _this.getDevNumber();
            }
            _this.getWarning();
            setInterval(function () {
              if (_this.$common.checkPower('8d1e6bfd-17a7-4a7e-9e9a-e4b92845dbd9')) {
                _this.getDevNumber();
              }
              _this.getWarning();//获取当前用户设备报警信息
            }, 60 * 1000)


            //判断是否有公司
            if (data.companyguid == "00000000-0000-0000-0000-000000000000") {
              this.Companydialog = true;
            } else {
              var isShow = localStorage.getItem('ShowNotice');

              if (isShow == null) {
                this.dialogVisible = true;
                localStorage.setItem('ShowNotice', 'true');
              }
            }


            //判断是否需要数据转移
            if (data.issyncmonitordata == true) {
              const loading = this.$loading({
                lock: true,
                text: this.$t('JS.trans'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.75)'
              });
              this.$axios.post(this.configUrl+"/User/SyncMonitorInfo", {})
                .then(res => {
                  let data = JSON.parse(res.data);
                  if (data.results.result) {
                    this.$message({
                      message: this.$t('AllPage.Success'),
                      type: 'success'
                    });
                    setTimeout(function () {
                      _this.$router.go(0)
                    }, 1000)
                  } else {
                    this.$message({
                      message: this.$t('JS.transError') + data.results.data,
                      type: 'warning'
                    });
                  }
                  loading.close();
                })
                .catch(err => {

                  loading.close();
                });

            } else {

            }
          })
          .catch(err => {

          });
      },

      JoinCompany() {//加入公司
        var _this = this;
        if (this.form.Code == '') {
          this.$message({
            message: this.$t('JS.codeinfo'),
            type: 'warning'
          });
          return;
        }
        this.$axios.post(this.configUrl+"/Company/JoinCompanyDept", {InviteCode: this.form.Code})
          .then(res => {
            var data = JSON.parse(res.data);
            if (data.results.result) {
              this.$message({
                message: this.$t('AllPage.Success'),
                type: 'success'
              });
              setTimeout(function () {
                _this.$router.go(0)
              }, 1000)
            } else {
              this.$message({
                message: data.results.data,
                type: 'warning'
              });
            }

          })
          .catch(err => {

          });

      },
      goto(e) {
        window.location.href = "http://vip.hzjly.cn/#/Index"
      },
    }
  }
</script>

<style scoped>
  >>> .el-input__inner{
    border: none;
  }
  .hovercompany:hover .showcompany {
    display: flex;
  }

  .showcompany button {
    height: 30px;
    line-height: 0;
    background-color: #e2b455;
    border-radius: 15px;
    padding: 12px 16px;
  }

  .showcompany {
    z-index: 999;
    -moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    font: 12px/1.5 Microsoft Yahei, Arial, Tahoma, sans-serif, Hiragino Sans GB;
    position: absolute;
    width: 266px;
    height: 46px;
    right: 0;
    display: none;
    justify-items: center;
    align-items: center;
    background-color: white;
    color: black;
    padding: 12px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
  }

  .showcompany p {
    line-height: 26px;
  }

  .el-menu-item:hover {
    background: #F6FAF9 !important;
    color: #247af0 !important;
  }

  .el-menu-item:hover i {
    color: #247af0 !important;
  }

  .el-menu-item:hover .el-dropdown-link {
    color: #247af0 !important;
  }

  .el-submenu__title {
    background: #F6FAF9 !important;
    color: #247af0 !important;
  }


  .el-dropdown-menu {
    margin-top: 5px !important;
  }


  /*.el-popper >>> .popper__arrow::after {*/
  /*border-width: 0px !important;*/
  /*}*/

  /*.el-popper[x-placement^=bottom] >>> .popper__arrow:after {*/
  /*border-bottom-color: blue;*/
  /*border-width: 0px !important;*/
  /*}*/
  /*.el-popper[x-placement^=bottom] >>> .popper__arrow {*/
  /*border-bottom-color: blue;*/
  /*border-width: 0px !important;*/
  /*}*/


</style>



// WEBPACK FOOTER //
// src/components/Header.vue